"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeSummaryBlockStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var palette = _a.palette, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        repaymentLabel: {
            marginLeft: 12,
        },
        financeQuotePrice: {
            color: palette.text.primary,
            fontSize: typography.fontXL,
        },
        labelAfter: (_b = {},
            _b[breakpoints.down('sm')] = {
                padding: '0 0 0 12px',
                display: 'block',
            },
            _b),
    });
}, { name: 'GqlSummary_FinanceSummaryBlock' });
exports.default = financeSummaryBlockStyles;
